// src/theme.js
import { createTheme } from '@mui/material/styles';

export const getTheme = (mode = 'light') => createTheme({
    palette: {
        mode,
        primary: {
            main: '#3bbca7', // teal
            contrastText: mode === 'dark' ? '#1a1a1a' : '#f5f7f6',
        },
        secondary: {
            main: '#6c7a89', // soft accent
            contrastText: mode === 'dark' ? '#f5f7f6' : '#1a1a1a',
        },
        background: {
            default: mode === 'dark' ? '#1a1a1a' : '#f5f7f6', // anthracite vs mist
            paper: mode === 'dark' ? '#2c2c2c' : '#f5f7f6',
        },
        text: {
            primary: mode === 'dark' ? '#f5f7f6' : '#1a1a1a',
            secondary: mode === 'dark' ? '#b0b8bf' : '#6c7a89',
            primary_dark: '#1a1a1a'
        },
        info: {
            main: '#a8e6cf',
        },
        success: {
            main: '#3bbca7',
        },
        warning: {
            main: '#f4c542',
        },
        error: {
            main: '#f28c8c',
        },
    },
    typography: {
        fontFamily: `'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif`,
        button: {
            fontWeight: 600,
        },
    },
    shape: {
        borderRadius: 10,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 500,
                    borderRadius: 10,
                },
            },
        },
    },
});
